/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.regexp.constructor";
import Mock from 'mockjs';
import * as api from "../api";
import { fetchUserInfo, fetchUserContact } from "./user";

var mock = function mock(api) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return Mock.mock.apply(Mock, [new RegExp(api)].concat(args));
}; // 获取用户信息


mock(api.fetchUserInfo, fetchUserInfo); // 获取用户联系人

mock(api.fetchUserContact, fetchUserContact);